import { render, staticRenderFns } from "./ReservationCreated.vue?vue&type=template&id=58c0c90c"
import script from "./ReservationCreated.vue?vue&type=script&lang=js"
export * from "./ReservationCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports